import {DistanceProps} from 'modules/cities/types';
import useApiMutation from 'shared/hooks/use-api-mutation';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import companiesKeys from '../util/companies-keys';

const useEditNeighborhoodPrice = (
  companyId: string,
  companyNeighborhoodPriceId: string,
) => {
  const {update, setData} = useQueryHelpers();

  const onSuccess = (data: DistanceProps) => {
    update(companiesKeys.neighborhoodPrices(companyId), data);
    setData(
      `/neighborhoods/company-prices/${companyNeighborhoodPriceId}`,
      data,
    );
  };

  return useApiMutation<DistanceProps>({
    url: `/neighborhoods/company-prices/${companyNeighborhoodPriceId}`,
    method: 'PATCH',
    errorTitle: 'Erro ao alterar bairro',
    successTitle: 'Bairro da empresa',
    successMessage: 'Bairro atualizado com sucesso',
    redirectUrl: `/settings/companies/${companyId}/neighborhood-prices`,
    onSuccess,
  });
};

export default useEditNeighborhoodPrice;
